export const PRICING_PLANS_API_URL = 'ui/organization/pricing_plans';
